module.exports = __webpack_public_path__ + "static/img/10.2029ebc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour4/10.jpg
// module id = C2kp
// module chunks = 0